<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    // Id of the modal, for v-b-modal.the-id
    modalId: {
      type: String,
      default: "delete-worker-modal",
    },

    // The worker ID possibly being deleted
    workerId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // toggle delete button disabled
      delDisabled: false,
    };
  },

  computed: {
    // The worker to delete
    worker() {
      return this.workers[this.workerId];
    },

    // Mapped vuex state
    ...mapState(["workers"]),
  },

  methods: {
    // Delete the worker, hide the modal, and go to the workers page
    async doDelete() {
      this.delDisabled = true;
      await this.deleteWorker({ workerId: this.workerId });
      this.delDisabled = false;
      this.hide();
      this.$router.push("/workers");
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["deleteWorker"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Confirm Delete"
    button-size="sm"
    hide-header-close
  >
    <p v-if="worker">
      Are you sure you want to delete
      <b>{{ worker.name }}</b>
      ? Doing so will also delete all its historical data.
    </p>
    <p v-if="worker">
      Any miner that is connected to mine.app using the username
      <b>{{ worker.team_handle }}.{{ worker.handle }}</b>
      will fail-over to another pool.
    </p>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button :disabled="delDisabled" variant="danger" @click="doDelete">
          Delete
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
